function normalizeTypeArgs(input) {
  if ("target" in input) {
    const data = input.target.split("::");
    if (data.length !== 3) {
      throw new Error("invalid type");
    }
    return data;
  }
  return [input.address, input.module, input.name];
}
function normalizeTypeArgsToStr(input) {
  if ("target" in input) {
    if (input.target.split("::").length !== 3) {
      throw new Error("invalid type");
    }
    return input.target;
  }
  return `${input.address}::${input.module}::${input.name}`;
}
export {
  normalizeTypeArgs,
  normalizeTypeArgsToStr
};
//# sourceMappingURL=util.js.map
